<template>
  <div>
    <v-dialog v-model="dialog" max-width="800px">
      <v-card>
        <img :src="preveiw" height="100%" width="100%" style="max-height: 600px; max-width:600px;object-fit: contain;" />
      </v-card>
    </v-dialog>

    <v-data-table
      :headers="headers"
      :items="items"
      :search="search"
      :items-per-page="100"
      :footer-props="{ itemsPerPageOptions: [25, 50, 100, -1] }"
    >
      <template v-slot:item.img_num="{ item }">
        <span v-for="n in toNum(item.img_num)" :key="n">
          <img
            @click="previewImg(item.id + '_' + (n - 1))"
            :src="
              'https://tool-test.matomeroyal.com/wp-content/themes/tool/appmediaTool/form/upload/' +
                item.id +
                '_' +
                (n - 1) +
                '.jpg'
            "
            style="max-height:140px;width:auto;max-width:100px;max-height:80px;padding:5px;"
          />
        </span>
      </template>
    </v-data-table>

    <!-- <ul>
    <li :key="item" v-for="item in list">      <img :src="'https://developer-test.royalantenna.com/wp-content/themes/ajaira/db_form/upload/image/'+item" width=200 />
      {{item}}
    </li>
</ul> -->
  </div>
</template>

<script>
// Ajax通信ライブラリ
import axios from "axios";

export default {
  components: {},
  data() {
    return {
      dialog: false,
      preveiw: "",

      headers: [
        {
          text: "id",
          value: "id",
          width: "30px",
          align: "center",
        },
        {
          text: "name",
          value: "title",
          width: "30px",
          align: "center",
        },
        {
          text: "添付画像",
          value: "img_num",
          width: "30px",
          align: "center",
        },
      ],

      itemsPerPage: 10,

      // list : [],

      items: [],
      search: "",
    };
  },

  computed: {},

  methods: {
    previewImg(img) {
      this.preveiw =
        "https://tool-test.matomeroyal.com/wp-content/themes/tool/appmediaTool/form/upload/" +
        img +
        ".jpg";
      console.log(this.preveiw);
      this.dialog = true;
    },

    toNum(num) {
      return parseInt(num);
    },

    getImageBBS() {
      axios
        .get(process.env.VUE_APP_FORM_LIST, {
          // params: { year: "2022", month: "04" },
        })
        .then((response) => {
          console.log(response);
          var self = this;
          response.data.forEach((element) => {
            self.items.push(element);
          });

          // console.log(this.list);
        });
    },
  },

  watch: {},

  created: function() {
    this.getImageBBS();
  },

  beforeCreate: function() {},
};
</script>

<style scoped>
ul {
  display: flex;
  flex-wrap: wrap;
}
li {
  display: inline-block;
  width: 20%;
  text-align: center;
  font-size: 11px;
  line-height: 1.2;
  margin: 20px auto;
  min-height: 180px;
}
/* .v-btn {
  justify-content: left !important;
} */
</style>
